import { render, staticRenderFns } from "./OverdueNoticeProcess.vue?vue&type=template&id=e6409afe&scoped=true&"
import script from "./OverdueNoticeProcess.vue?vue&type=script&lang=ts&"
export * from "./OverdueNoticeProcess.vue?vue&type=script&lang=ts&"
import style0 from "./OverdueNoticeProcess.vue?vue&type=style&index=0&id=e6409afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6409afe",
  null
  
)

export default component.exports